
import { Component, Prop, Vue } from "vue-property-decorator";
import BookingViewDatePicker from "@/components/booking/components/BookingViewDatePicker.vue";
import DialogBanner from "@/components/app/DialogBanner.vue";
import TimeService from "@/services/TimeService";
import RemoteServices from "@/services/RemoteServices";
import Restaurant from "@/domain/restaurant/Restaurant";
@Component({
  components: { DialogBanner, BookingViewDatePicker }
})
export default class SpecialOpenDayDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  date: Date = new Date();

  @Prop()
  restaurant!: Restaurant;

  loading = false;

  get dialog() {
    return this.value;
  }

  set dialog(newVal: boolean) {
    this.$emit("input", newVal);
  }

  updateDate(newDate: Date) {
    this.date = newDate;
  }

  closeAndResetDialog() {
    this.dialog = false;
    this.loading = false;
  }

  emitNewSpecialOpenDate(newDate: string) {
    this.$emit("new-open-date", newDate);
  }

  async addSpecialOpenDate() {
    this.loading = true;
    try {
      this.emitNewSpecialOpenDate(
        await RemoteServices.addSpecialOpenDate(
          TimeService.getISODateString(this.date),
          this.restaurant.restaurantId
        )
      );
      await this.$store.dispatch(
        "success",
        this.$t("restaurant.specialOpenDates.create.success")
      );
      this.closeAndResetDialog();
    } catch (error) {
      await this.$store.dispatch("error", error.message);
    }
    this.loading = false;
  }
}
